import React, { Component } from 'react';
import { FormGroup } from '@blueprintjs/core';
import Select from 'react-select';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import customStyles from 'utils/select-styles';

class FormSelectGroup extends Component {
  static defaultProps = {
    isClearable: true,
  };

  handleChange = value => {
    if (this.props.name === 'prescreen') {
      this.props.onChange(`prescreen.${this.props.index}`, value);
    } else {
      this.props.onChange(this.props.name, value);
    }
  };
  handleBlur = () => {
    if (this.props.name !== 'vendorContact' && this.props.onBlur) {
      this.props.onBlur(this.props.name, true);
    }
  };

  render() {
    return (
      <FormGroup
        inline={false}
        label={this.props.label}
        labelFor="select"
        className={this.props.class || ''}
        labelInfo={this.props.requiredLabel && '(required)'}
        style={{ maxWidth: this.props.maxWidth }}
      >
        <Select
          id="select"
          value={this.props.value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          options={
            this.props.max !== 0 &&
            this.props.value &&
            this.props.value.length >= this.props.max
              ? this.props.value
              : this.props.asyncOptions
          }
          placeholder={this.props.placeholder}
          isSearchable
          styles={customStyles}
          getOptionLabel={option => option[this.props.labelKey]}
          getOptionValue={option => option[this.props.valueKey]}
          isMulti={this.props.multi}
          isClearable={this.props.isClearable}
          isDisabled={this.props.disabled || false}
          noOptionsMessage={() =>
            this.props.noOptionsMessage
              ? this.props.noOptionsMessage
              : this.props.value && this.props.max === this.props.value.length
              ? `You may only select ${this.props.max} answers to this question`
              : 'No options'
          }
        />
        <ErrorMessage
          name={this.props.name}
          render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
        />
      </FormGroup>
    );
  }
}

export default FormSelectGroup;
